module.exports = __webpack_public_path__ + "img/126.91b0061d.jpg";